import { useTenantGroup } from '../../hooks/useTenantGroup'
import { Badge } from '../Badge/Badge'
import type { TenantGroupBadgeProps } from './TenantGroupBadge.types'

export function TenantGroupBadge({ tenantGroupId }: TenantGroupBadgeProps) {
  const { tenantGroup } = useTenantGroup(tenantGroupId)
  return <Badge color="grey">{tenantGroup?.code ?? tenantGroupId}</Badge>
}
